import { Switch, Route } from 'wouter'

import AddFeed from './AddFeed'
import AdminFeeds from './AdminFeeds'
import App from './App'
import { AuthProvider } from './AuthProvider'
import Login from './Login'
import RequireAdmin from './RequireAdmin'
import RequireAuth from './RequireAuth'

export default function Router() {
  return (
    <AuthProvider>
      <Switch>
        <Route path="/login"><Login /></Route>
        <Route path="/admin">
          <RequireAdmin><AdminFeeds /></RequireAdmin>
        </Route>
        <Route path="/add">
          <RequireAuth><AddFeed /></RequireAuth>
        </Route>
        <Route path="/feed/:id">
          <RequireAuth><App /></RequireAuth>
        </Route>
        <Route path="/">
          <RequireAuth><App /></RequireAuth>
        </Route>
      </Switch>
    </AuthProvider>
  )
}
